import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Profile = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="82" height="82" viewBox="0 0 82 82">
      <defs>
        <filter id="Ellipse_361" x="0" y="0" width="82" height="82" filterUnits="userSpaceOnUse">
          <feOffset dy="3" />
          <feGaussianBlur stdDeviation="3" result="blur"/>
          <feFlood floodOpacity="0.161"/>
          <feComposite operator="in" in2="blur"/>
          <feComposite in="SourceGraphic"/>
        </filter>
      </defs>
      <g id="profil" transform="translate(-75.402 -93.401)">
        <g transform="matrix(1, 0, 0, 1, 75.4, 93.4)" filter="url(#Ellipse_361)">
          <circle id="Ellipse_361-2" data-name="Ellipse 361" cx="32" cy="32" r="32" transform="translate(9 6)" fill="#6c5ce7"/>
        </g>
        <circle id="Ellipse_362" data-name="Ellipse 362" cx="24.146" cy="24.146" r="24.146" transform="translate(93.915 100.666)" fill="#fff" opacity="0.07"/>
        <path id="Tracé_942" data-name="Tracé 942" d="M226.692,139.628c-.046.915-1.155,1.625-2.478,1.558s-2.356-.872-2.308-1.8,1.155-1.622,2.478-1.555S226.741,138.7,226.692,139.628Z" transform="translate(-95.788 -26.711)" fill="#263238"/>
        <path id="Tracé_943" data-name="Tracé 943" d="M145.787,145.872c.177.915-.735,1.853-2.033,2.106s-2.5-.28-2.673-1.192.732-1.856,2.033-2.109S145.613,144.961,145.787,145.872Z" transform="translate(-39.587 -31.43)" fill="#263238"/>
        <ellipse id="Ellipse_363" data-name="Ellipse 363" cx="4.509" cy="1.68" rx="4.509" ry="1.68" transform="translate(98.612 118.054)" fill="#6c5ce7"/>
        <path id="Tracé_944" data-name="Tracé 944" d="M231.4,152.306c.137.884-1.674,1.9-4.042,2.274s-4.4-.046-4.545-.93,1.674-1.9,4.042-2.271S231.269,151.422,231.4,152.306Z" transform="translate(-96.414 -36.038)" fill="#6c5ce7"/>
        <path id="Tracé_945" data-name="Tracé 945" d="M169.191,168.344a40.944,40.944,0,0,1,15.16-1.716.75.75,0,0,1,.661.851c-.75,5.889-11.639,7.1-16.156,2.061a.738.738,0,0,1,.335-1.195Z" transform="translate(-58.782 -46.639)" fill="#263238"/>
        <path id="Tracé_946" data-name="Tracé 946" d="M188.443,174.6a5.3,5.3,0,0,0-1.119.466,4.21,4.21,0,0,0-2.936-.122,4.491,4.491,0,0,0-3.009,2.5,12.642,12.642,0,0,0,6.981.448,8.153,8.153,0,0,0,4.106-2.119C191.934,174.6,190.257,174.076,188.443,174.6Z" transform="translate(-67.617 -52.135)" fill="#6c5ce7" opacity="0.6"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Profile;